export default {"src":"/_next/static/media/icon_popcorn.b58fdcaf.svg","height":36,"width":29,"blurWidth":0,"blurHeight":0};